import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicePage.css';

function OfficeSetup() {
  const navigate = useNavigate();
  return (
    <div className="service-page">
      <header className="service-header">
        <h1>Office Setup</h1>
        <p>Design and implement efficient office IT infrastructure tailored to your business.</p>
      </header>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>
      <div className="service-container">
        <section className="service-section">
          <h3>Services</h3>
          <ul>
            <li>Network design & cabling</li>
            <li>Workstation, server and peripheral setup</li>
            <li>Security & access control integration</li>
          </ul>
        </section>

        <div className="service-cta">
          <a href="/contact">Get Office Consultation</a>
        </div>
      </div>
    </div>
  );
}

export default OfficeSetup;
